import { Controller } from "react-hook-form";
import { Autocomplete, TextField, Typography, Popper } from "@mui/material";
import { matchSorter } from "match-sorter";
import { isEmpty } from "lodash";

import { NO_OPTIONS } from "../constants/ResponseMessage";
import { ListOptions } from "../models/Master";
import { NoOptionTextStyle } from "../routes/HomeScreen/style/style";
import { removeAccents } from "../utils";
import { multiLineStyle } from "./styles/styles";

export interface ComponentTypes {
  control: any;
  list: ListOptions[];
  value: ListOptions;
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  handleChange: any;
  sx?: any;
  variant?: any;
  isScorecard?: boolean;
  disableFilter?: boolean;
}
export const FormAutocompleteList = ({
  control,
  list,
  value,
  open,
  onOpen,
  onClose,
  handleChange,
  sx,
  variant,
  isScorecard,
  disableFilter,
}: ComponentTypes) => {
  return (
    <Controller
      render={(field) => (
        <Autocomplete
          sx={sx}
          disabled={isEmpty(list)}
          options={list}
          forcePopupIcon
          value={value}
          getOptionLabel={(option: any) => option.label}
          open={open}
          onOpen={() => onOpen()}
          onClose={() => onClose()}
          disableClearable
          filterOptions={(options: any, { inputValue }) => {
            if (disableFilter) {
              return options;
            }
            const normalizedInput = removeAccents(inputValue);
            return matchSorter(options, normalizedInput, { keys: ["label"] });
          }}
          isOptionEqualToValue={(option, value) => option.label === value.label}
          id="auto-complete"
          autoComplete
          clearIcon={""}
          onChange={handleChange}
          includeInputInList
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                {...field}
                variant={variant ? variant : "outlined"}
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                }}
                {...(isScorecard && { multiline: true, rows: 2 })}
                sx={{
                  "& .MuiAutocomplete-inputRoot": {
                    padding: "0 0.6rem 0 0",
                  },
                }}
              />
            );
          }}
          noOptionsText={
            <Typography variant="h4" align="center">
              {NO_OPTIONS}
            </Typography>
          }
          PopperComponent={CustomPopper}
          renderOption={(props, option) => {
            return (
              <Typography {...props} key={option.value} sx={multiLineStyle}>
                {option.label}
              </Typography>
            );
          }}
        />
      )}
      name="providerId"
      control={control}
    />
  );
};

const CustomPopper: React.FC<React.ComponentProps<typeof Popper>> = (props) => (
  <Popper {...props} sx={NoOptionTextStyle} />
);
